import { render, staticRenderFns } from "./WFStarNode.vue?vue&type=template&id=0f684836&scoped=true"
import script from "./WFStarNode.vue?vue&type=script&lang=js"
export * from "./WFStarNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f684836",
  null
  
)

export default component.exports